import { render, staticRenderFns } from "./DimensionSelectionForm.vue?vue&type=template&id=42bd59b1&"
import script from "./DimensionSelectionForm.vue?vue&type=script&lang=js&"
export * from "./DimensionSelectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports